import './Home.css';
import Boxes from "../components/Boxes"
import SelectorPlots from '../components/SelectorPlots';
import React, { useState } from 'react';
import VideoEnirisst from "../images/ENIRISST_VID.mp4";
import DownloadAirportsButton from "../components/DownloadAirportButton"
import MapData from "../components/FetchMapData"
import Top10AirportsChart from "../components/Top10Airports"
import AnnualTrafficChange from "../components/AnnualTrafficChange"
import TrafficByRegion from '../components/TrafficByRegion';
import SeasonalMovement from '../components/SeasonalMovement';
import MostEfficientAirports from '../components/MostEfficientAirports';
import Top10Airplanes from '../components/Top10Airplanes';
import Connections from '../components/Connections';
import Table1 from "../components/FetchTable1"
import Table2 from "../components/FetchTable2"
import Table3 from "../components/FetchTable3"
import Table4 from "../components/FetchTable4"
import ClipLoader from 'react-spinners/ClipLoader';



function App() {

  //State for updating the year
  const [year_var, setYear] = useState(2017);

  //states for the cliploader
  const [loading1, setloading1] = useState(true);
  const [loading2, setloading2] = useState(true);
  const [loading3, setloading3] = useState(true);
  const [loading4, setloading4] = useState(true);
  const [loading5, setloading5] = useState(true);
  const [loading6, setloading6] = useState(true);
  const [loading7, setloading7] = useState(true);
  const [loading8, setloading8] = useState(true);
  const [loading9, setloading9] = useState(true);
  const [loading10, setloading10] = useState(true);
  const [loading11, setloading11] = useState(true);

  let sectionStyle = {
    display: !loading2 && !loading1 && !loading3 && !loading4 && !loading5 && !loading6 && !loading7 && !loading8 && !loading9 && !loading10 && !loading11? 'block' : 'none',
  };

  
  /*-----------------------------------------------------BACKEND ACCESS--------------------------------------*/



  //------------------------------------------------------TABLES-----------------------------------

  // const [minmaxYears, setyears] = useState();


  // // Get years for selector
  // useEffect(() => {
  //   fetch("api/minmaxyears").then((res) =>
  //     res.json().then((res) => {
  //       // console.log("Response: ",res.data)
  //       var dataTable = []
  //       dataTable.push({"min_year": res.data["min_year"]})
  //       dataTable.push({"max_year": res.data["max_year"]})
  //       setyears(dataTable);
  //     })
  //   )
  //   .catch((error) => {
  //     console.log("Refetching data for years!")
  //   });
  // }, []);

  
      return (
        
        <div>
          

          {/*-------------------------------------------------------BOXES---------------------------------------------- */}
          <section id="FirstPage">
            <div className="container">
              <div className='row'>
                <div className = "col-lg-6">
                  <div id = "HeaderPos">
                    <h1 className = "HeadTitle" > Παρατηρητήριο για τις <br></br> Αεροπορικές Μεταφορές</h1>
                    <p className = "NameTitle"> Είσαι ερευνητής/φορέας/ιδιωτική εταιρία/ελεύθερος επαγγελματίας;</p>
                    

                    <p>Αυτή η πλατφόρμα μπορεί να σου προσφέρει πληροφορίες σχετικά με: </p>
                    <Boxes className = "Boxes" title="Επιβατική Κίνηση" subtitle = "Των ελληνικών αεροδρομίων." title2 = "Εμπορευματική Κίνηση" subtitle2 ="Το περιβαλλοντικό."></Boxes>
                    <Boxes className = "Boxes" title="Λειτουργικά Χαρακτηριστικά" subtitle = "Των ελληνικών αεροδρομίων." title2 = "Τεχνικά Χαρακτηριστικά" subtitle2 ="Των ελληνικών αεροδρομίων."></Boxes>
                    <Boxes className = "Boxes" title="Αποδοτικότητα" subtitle = "Των ελληνικών αεροδρομίων." title2 = "Εμπορευματική Κίνηση" subtitle2 ="Των ελληνικών αεροδρομίων."></Boxes>
                  </div>
    
    
    
                </div>
                <div className='col-lg-6' id = "Video-pos">
                  <video width="600" height="600" controls>
                    <source src={VideoEnirisst} type="video/mp4"/>
                  </video>
                  <p id = "video-subtitle"> Περιηγηθείτε μέσα στην υπηρεσία μέσα από το παραπάνω βίντεο.</p>
                </div>
              </div>
            </div>
    
    
          </section>
          
          
          <div className ="Selector container"> <SelectorPlots passData = {setYear} setloading1 = {setloading1} setloading2 = {setloading2}  setloading3 = {setloading3}  setloading4 = {setloading4}  setloading5 = {setloading5} setloading6 = {setloading6} setloading7 = {setloading7} setloading8 = {setloading8} setloading9 = {setloading9} setloading10 = {setloading10} setloading11 = {setloading11}> </SelectorPlots> </div>
          {/* ------------------------------------------------- SELECTOR ---------------------------------------------*/}

          {/* {loading1 || loading2 || loading3 || loading4 || loading5 || loading6 || loading7 || loading8 || loading9 || loading10 || loading11? 
          <div className='container' style = {{marginLeft: "40%"}}>
            <ClipLoader size={200} color={'#123abc'} loading={true}/> </div>: <></>} */}
            {/* style={sectionStyle} */}
          <section id = "SecondPage" >
            

          
          {/*------------------------------------------------- SIDE NAVIGATION TABLE ------------------------- */}
            <aside className='side-nav'>
              <div className='container'>
                <h5>Περιήγηση περιεχομένου</h5>
                <nav className='nav-item'>
                  <a href ="#Plot1" className='nav-link'> Αθροιστικά Δεδομένα</a>
                </nav>
                <nav className='nav-item'>
                  <a href ="#Chart1" className='nav-link'> Συνολική Κίνηση</a>
                </nav>
                <nav className='nav-item'>
                  <a href ="#Chart2" className='nav-link'> Top 10 αεροδρόμια</a>
                </nav>

                <nav className='nav-item'>
                  <a href ="#Chart3" className='nav-link'> Top 10 συνδέσεις</a>
                </nav>

                <nav className='nav-item'>
                  <a href ="#Chart4" className='nav-link'> Τύποι Αεροσκαφών</a>
                </nav>
                
                <nav className='nav-item'>
                  <a href ="#Chart5" className='nav-link'> Αποδοτικότητα</a>
                </nav>

                <nav className='nav-item'>
                  <a href ="#Chart5" className='nav-link'> Εποχικότητα</a>
                </nav>

                <nav className='nav-item'>
                  <a href ="#Chart6" className='nav-link'> Κίνηση ανά περιοχή</a>
                </nav>
              </div>
          </aside>


            {/* ------------------------------------------------ TABLES -----------------------------------------------*/}
            
            <div className="container wrapper" id = "Plot1">
                <hr></hr>
                <p><b>Αθροιστικά Δεδομένα των ελληνικών αεροδρομίων</b>(Πτήσεις Ελλάδα)</p>
                <div className='row'>
                  <div className = "col-lg-6 col-md-12 w-100">
                    <Table1  year = {year_var} setloading1 = {setloading1}></Table1>
                  </div>
                  <div className='col-lg-6 col-md-12 w-100'>
                    <Table2 year = {year_var} setloading2 = {setloading2}> </Table2>
                  </div>
                </div>
                <div className='row' id = "Tables-row">
                  <div className = "col-lg-6" >
                    <Table3 year = {year_var} setloading3 = {setloading3}></Table3>
      
                  </div>
                  <div className='col-lg-6'>
                    <Table4  year = {year_var} setloading4 = {setloading4}> </Table4>
                  </div>
                </div>
              </div>

            {/*------------------------------------------------ CHARTS ---------------------------------------*/}

            {/* ------------------------------------------------ CHART 1--------------------------------------*/}
            <div className = "container wrapper"  id = "Chart1"> 
              <hr></hr>
              <h5>Ετήσια μεταβολή της κίνησης των ελληνικών αεροδρομίων</h5>
              <AnnualTrafficChange setloading5={setloading5}> </AnnualTrafficChange>
            </div>
            



            {/* ----------------------------------------------- CHART 2 --------------------------------------*/}
            
            <div className = "container wrapper"  id = "Chart2"> 
              <hr></hr>
              <h5>Top 10 αεροδρόμια(σε επιβάτες)</h5>
              <p>Διάστημα ετών(2010-2017)</p>
              
              <Top10AirportsChart setloading6={setloading6}> </Top10AirportsChart>
              <div style = {{marginLeft: "80%"}}>
                <DownloadAirportsButton></DownloadAirportsButton>
              </div>
            </div>

          {/* ------------------------------------------- CHART 3------------------------------------ */}
            <div className = "container wrapper" id = "Chart3">
              <hr></hr>
              <h5>Top 10 συνδέσεις(σε επιβάτες)</h5>
              <p>Τρέχον έτος({year_var})</p>
              <Connections year = {year_var} setloading7={setloading7}></Connections> 
            </div>
            
            {/* ------------------------------------------------ DOUGHNUT CHART ------------------------------ */}
            <div className = "container wrapper"  id = "Chart4"> 
              <hr></hr>
              <h5>Τύποι αεροσκαφών</h5>
              <p>Τρέχων έτος({year_var})</p>
              <Top10Airplanes  year = {year_var} setloading8={setloading8}></Top10Airplanes>
              
            </div>


            {/* ------------------------------------------------DOUBLE DATASETS BARCHART------------------------------ */}

            <div className = "container wrapper" id = "Chart5">
              <div className='row w-100'>
                <div className = "col-lg-6 col-md-12">
                  <hr></hr>
                  <h5>Top 10 Αποδοτικότερα Ελληνικά Αεροδρόμια</h5>
                    <MostEfficientAirports  year = {year_var} setloading9={setloading9}> </MostEfficientAirports>
                    <div style = {{marginLeft: "69%"}}>
                      <DownloadAirportsButton></DownloadAirportsButton>
                    </div>
                  
                </div>
                <div className='col-lg-6 col-md-12'>
                  <hr></hr>
                  <h5>Top 10 Ελληνικά Αεροδρόμια με Εποχική Κίνηση</h5>
                
                    <SeasonalMovement  year = {year_var} setloading10={setloading10}> </SeasonalMovement>
                    <div style = {{marginLeft: "69%"}}>
                      <DownloadAirportsButton></DownloadAirportsButton>
                    </div>
  
                  
                  {/* <p style = {{marginLeft: "65%"}}>*Gini: lorem ipsum...</p> */}
                </div>
              </div> 
            </div>


            {/* ----------------------------------------------MIXED CHART--------------------------------- */}
            <div className = "container wrapper"  id = "Chart6"> 
              <hr></hr>
              <h5>Κίνηση ανά γεωγραφική περιοχή</h5>
              <p>Εμπορεύματα και ταχυδρομειο</p>
              
              <TrafficByRegion year = {year_var} setloading11={setloading11}></TrafficByRegion>
              
            </div>
            
          </section>

          <MapData year = {year_var}> </MapData>
    
        </div>
      );
     
  }

export default App;
